import { Component } from 'preact';
import { NavigationBase } from './navigationBase';

class NavigationFinalLinks extends Component {

  // the user has permission to view the item, or any sub item or final item on it
  userHasPermission = (finalItem, account) => {
    const finalItemPermissions = finalItem.Permissions;

    if (!account || !account.Permissions) {
      return false;
    }

    if (!finalItemPermissions || finalItemPermissions.length <= 0) {
      return true;
    }

    const currentUserPermissions = account.Permissions;

    // the user must have at least one of the permissions to have access
    const isPermitted = finalItemPermissions.some((permissionRequired) => {

      // return currentUserPermissions.indexOf(permissionRequired) !== -1
      return (currentUserPermissions.map((permission) => {
        return !permissionRequired || (permission.Action === permissionRequired.Action &&
          permission.Name === permissionRequired.Name &&
          permission.Prefix === permissionRequired.Prefix &&
          permission.UserType === permissionRequired.UserType);
      }).filter(m => m)).length > 0;
    });

    return isPermitted
  }
  render(props, state) {
    let account = props.account;
    let userHasPermission = (finalItem, account) => this.userHasPermission(finalItem, account);

    return <div> {props.subItem.FinalItems.map(function(finalItem, index) {
      const hasPermission = userHasPermission(finalItem, account);

      finalItem.quickAccess = [props.item.quickAccess[0], props.subItem.quickAccess[1], index]
      // the final item in the list is active
      const active = (
        props.activatedPath.item === props.item.Name &&
        props.activatedPath.subItem === props.subItem.Name &&
        props.activatedPath.finalItem === finalItem.Name
      )

      const linkClass = "navigation-final-link" + (active? " active" : " ")
      const linkAction = e => {
        props.setPathActive(props.item.Name, props.subItem.Name, finalItem.Name)
        props.navigationCallback(finalItem.Path)
      }

      return (
        <div>
        {hasPermission && !finalItem.External &&
          <div className={linkClass} onClick={linkAction}>
            <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={false} open={false} item={finalItem}></NavigationBase>
          </div>
        }
        {hasPermission && finalItem.External &&
          <a href={finalItem.Path} className={"navigation-final-link external-link"}>
            <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={false} open={false} item={finalItem}></NavigationBase>
          </a>
        }
        </div>
      );
    })}
    </div>
	}
}

export {NavigationFinalLinks};



// WEBPACK FOOTER //
// ./components/sidebar/navigationFinalLink.js